import React from 'react'

function Subheader({children}) {
    return (
        <div className="subheader">
            {children}
        </div>
    )
}

export default Subheader